import { GuardianRequestInfo } from "@/data/common/guardian-request-info";
import { PatientRequestInfo } from "@/data/common/patient-request-info";
import { CreatePatientWithGuardianPayload } from "@/data/payload/create-patient-with-guardian-payload";
import { CreatePatientResponseEntity } from "@/domain/entity/create-patient-response-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATErrorType, SATResult } from "@sadtx/sat-error";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";

export class EnrollPatientUsecase {
  //MARK:- init
  constructor(
    private readonly userRepo: UserRepository,
    private readonly patientListCache?: CacheInvalidator,
  ) {}

  //MARK: - execute
  async execute(
    patientInfo: PatientRequestInfo,
    guardianInfo: GuardianRequestInfo,
    hospitalCode: string,
  ): Promise<SATResult<CreatePatientResponseEntity, SATError>> {
    if (hospitalCode === undefined) {
      return SATResult.failure(
        new SATError(
          SATErrorType.NetworkError,
          "등록에 실패했습니다. 병원 코드를 가져올 수 없습니다.",
        ),
      );
    }

    console.log(
      "[EnrollPatientUsecase] :: execute :: 환자 등록 요청 시작",
      patientInfo,
      guardianInfo,
      hospitalCode,
    );
    const createPatientWithGuardianPayload: CreatePatientWithGuardianPayload = {
      patient: patientInfo,
      guardian: {
        ...guardianInfo,
        email: guardianInfo.email?.toLowerCase(),
      },
      hospitalCode: hospitalCode,
    };

    console.log("[EnrollPatientUsecase] :: execute :: 병원코드 ", hospitalCode);
    console.log(
      "[EnrollPatientUsecase] :: execute :: 환자 등록 요청 시작",
      createPatientWithGuardianPayload,
    );

    const result = await this.userRepo.createPatientWithGuardian(createPatientWithGuardianPayload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    // 환자 목록 캐시가 변경 전 데이터를 보여주지 않도록 비움
    this.patientListCache?.invalidate();
    console.log("[EnrollPatientUsecase] :: execute :: 환자 등록 성공 :: result", result.value);
    return SATResult.success(result.value);
  }
}
